import React, { useEffect, useMemo, useState } from "react";
import DynamicField from "../../../reusableComponents/DynamicForm/DynamicField";
import { Close } from "@mui/icons-material";
import { CircularProgress, Typography } from "@mui/material";
import { customToast } from "../../../reusableComponents/customToaster/customToast";
import { sortArrayValue } from "../../utils/utils";
import { colorBrandObject } from "../../../../constants/brandings";

function DynamicForm({
  field,
  index,
  updateField,
  condition,
  fields,
  setFields,
  processors,
  handleResetProcessor,
  resetFields,
  addMoreCondition,
}) {
  const [clearStateLoader, setClearStateLoader] = useState(false);
  const selectedFields = useMemo(
    () => fields?.map((el) => el.field) || [],
    [fields]
  );

  const filteredConditionFieldOptions = useMemo(() => {
    return (
      sortArrayValue(
        condition?.map((el) => ({
          title: el?.field?.title,
          value: el?.field?.value,
          disabled: selectedFields.includes(el?.field?.value),
        })),
        "title"
      ) || []
    );
  }, [condition, selectedFields]);

  const currentCondition = useMemo(() => {
    return condition?.find((el) => el?.field?.value === field?.field);
  }, [condition, field]);

  const updatedState = useMemo(() => {
    if (!currentCondition)
      return { typeOfValue: "string", operatorOptions: [], valuesOptions: [] };
    let validValuesOptions = currentCondition?.validValues;
    if (validValuesOptions?.length > 1) {
      validValuesOptions = sortArrayValue(validValuesOptions, "title");
    }
    const baseOptions = {
      typeOfValue: currentCondition?.field?.type || "string",
      operatorOptions: currentCondition?.validOperators || [],
      valuesOptions: validValuesOptions || [],
    };

    if (
      field?.operator?.toLowerCase() === "excludes" &&
      field?.values?.length == currentCondition?.validValues?.length - 1
    ) {
      baseOptions.valuesOptions = baseOptions.valuesOptions.map((el) => ({
        ...el,
        disabled: !field?.values?.includes(el.value),
      }));
    }

    return baseOptions;
  }, [currentCondition, field]);

  const handleFormatForm = (value) => {
    if (processors) {
      handleResetProcessor();
    }
    if (fields?.length - 1 >= index) {
      if (!processors && fields?.length - 1 > index) {
        customToast(
          "warning",
          "medium",
          "Changing previous condition resets next conditions"
        );
      }
      setFields((state) => state.slice(0, index + 1));

      if (value === "field") {
        updateField(index, "operator", "");
        updateField(index, "values", "");
      } else if (value === "operator") {
        updateField(index, "values", "");
      }
    }
  };

  const handleSetSingleOptionsField = () => {
    if (updatedState?.valuesOptions?.length == 1 && !field?.value) {
      if (
        updatedState?.typeOfValue == "MultiSelectOption" ||
        updatedState?.typeOfValue == "SingleSelectOption"
      ) {
        updateField(index, "values", updatedState?.valuesOptions[0].value);
      }
    }
  };

  const handleRemoveFields = async () => {
    handleResetProcessor();
    if (index) {
      setFields((state) => state.slice(0, index));
    } else {
      setClearStateLoader(true);
      await addMoreCondition(true);
      resetFields();
      setClearStateLoader(false);
    }
  };

  return (
    <div
      className="d-flex align-items-center mb-4 mt-2"
      style={{ gap: "20px", position: "relative" }}
    >
      <div style={{ maxWidth: "250px", width: "20%", minWidth: "180px" }}>
        <DynamicField
          type="SingleSelectOption"
          placeholder="Select Field"
          options={filteredConditionFieldOptions}
          value={field.field}
          onChange={(value) => {
            updateField(index, "field", value);
            handleFormatForm("field");
          }}
          style={{ width: "100%" }}
        />
      </div>

      {field?.field && (
        <div style={{ maxWidth: "250px", width: "20%", minWidth: "180px" }}>
          <DynamicField
            type="SingleSelectOption"
            placeholder="Select Operator"
            options={updatedState.operatorOptions}
            value={field.operator}
            onChange={(value) => {
              updateField(index, "operator", value);
              handleFormatForm("operator");
              handleSetSingleOptionsField();
            }}
            style={{ width: "100%" }}
          />
        </div>
      )}

      {field?.operator && (
        <div style={{ maxWidth: "250px", width: "20%", minWidth: "180px" }}>
          <DynamicField
            type={updatedState?.typeOfValue}
            placeholder={`Enter ${currentCondition?.field?.title}`}
            options={updatedState?.valuesOptions}
            value={field.values}
            onChange={(value) => {
              updateField(index, "values", value);
              handleFormatForm();
            }}
            style={{ width: "100%" }}

          />
        </div>
      )}

      {field?.operator?.toLowerCase() === "between" && (
        <>
          <Typography style={{ color: "#7F7D83" }}>To</Typography>

          <div style={{ maxWidth: "250px", width: "20%", minWidth: "180px" }}>
            <DynamicField
              type={updatedState.typeOfValue}
              placeholder={`Enter ${currentCondition?.field?.title}`}
              options={updatedState.valuesOptions}
              value={field.values2}
              onChange={(value) => {
                updateField(index, "values2", value);
              }}
              style={{ maxWidth: "250px", width: "100%" }}
            />
          </div>
        </>
      )}

      {/* {fields?.length > 1 && ( */}
      <div style={{ maxWidth: "50px", width: "50px" }}>
        <span className="clearRuleIcons" onClick={handleRemoveFields}>
          {clearStateLoader ? (
            <CircularProgress
              size={16}
              sx={{ color: colorBrandObject["primary"] }}
            />
          ) : (
            <Close style={{ height: 16, width: 16, color: "#7F7D83" }} />
          )}
        </span>
      </div>
      {/* )} */}

      {index > 0 ? (
        <div className="timelineSeparator">
          <span className="timelineText">and</span>
        </div>
      ) : (
        <div className="timelineSeparator2">
          <span className="timelineSeparatorDot" />
        </div>
      )}
    </div>
  );
}

export default DynamicForm;
